export default "__VITE_ASSET__2dfd9182__"